import {
  Box,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
} from '@chakra-ui/react'
import type { PropsWithChildren, ReactElement } from 'react';
import { useMemo } from 'react'
import BulkEditModeDropdown from './BulkEditModeDropdown'
import type { CMFieldProps } from '.'

const CMTextField = ({
  cmField,
  disabled,
  readOnly,
  placeholder,
  form,
  children,
  isUpload,
  labelElement,
  showBulkEditFieldModeDropdown,
  bulkEditFieldMode,
  style,
  required,
  menuPosition,
  setBulkEditFieldMode,
  onInputChange,
}: PropsWithChildren<CMFieldProps>): ReactElement => {
  const shouldShowFormField = useMemo(() => {
    if (!showBulkEditFieldModeDropdown) {
      return true
    }

    return bulkEditFieldMode?.[cmField.name] === 'set'
  }, [bulkEditFieldMode, cmField.name, showBulkEditFieldModeDropdown])
  return (
    <FormControl
      isInvalid={Boolean(form.errors?.upload?.[cmField.name])}
      isRequired={cmField.schema.isValueRequired}
      isDisabled={disabled}
      marginBottom={isUpload ? 0 : '30px'}
      style={style}
    >
      {labelElement ?? <FormLabel>{cmField.label}</FormLabel>}
      <Box width="100%">
        {showBulkEditFieldModeDropdown &&
          bulkEditFieldMode &&
          setBulkEditFieldMode && (
            <BulkEditModeDropdown
              bulkEditFieldMode={bulkEditFieldMode}
              setBulkEditFieldMode={setBulkEditFieldMode}
              cmField={cmField}
              disabled={readOnly || disabled}
              menuPosition={menuPosition}
              onInputChange={() => {
                onInputChange?.(cmField, form)
              }}
            />
          )}
        {shouldShowFormField && (
          <>
            <Input
              type="text"
              value={form.values?.upload?.[cmField.name] || ''}
              disabled={disabled}
              readOnly={readOnly || disabled}
              onChange={e => {
                const value = e.target.value
                if (value.length === 0) {
                  form.setFieldValue(`upload.['${cmField.name}']`, null)
                } else {
                  form.setFieldValue(`upload.['${cmField.name}']`, value)
                }
                onInputChange?.(cmField, form, value.length === 0 ? undefined : value)
              }}
              required={required}
              placeholder={placeholder}
            />
            <FormErrorMessage>{form.errors?.upload?.[cmField.name]}</FormErrorMessage>
          </>
        )}
      </Box>
      {children}
    </FormControl>
  )
}


export default CMTextField
